import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { NAV } from "../../content/site";
import { scrollToId } from "../../lib/scroll";
import { Logo } from "./Logo";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,padding] duration-500 ${
        scrolled ? "bg-cream/85 backdrop-blur-xl shadow-[0_1px_0_rgba(139,122,79,0.18)] py-2.5" : "bg-cream/55 backdrop-blur-md py-4"
      }`}
      data-testid="header-navbar"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 sm:px-8 lg:px-12">
        <button onClick={() => go("home")} aria-label="Glow Motion Pictures home" data-testid="header-logo">
          <Logo />
        </button>
        <nav className="hidden xl:flex items-center gap-8" data-testid="desktop-nav">
          {NAV.map((n) => (
            <button key={n.id} onClick={() => go(n.id)} className="group relative text-[13px] tracking-wide text-ink" data-testid={`nav-${n.id}`}>
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-gold transition-transform duration-500 group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button onClick={() => go("contact")} className="btn-gold !px-5 !py-2.5 hidden sm:inline-flex" data-testid="header-book-btn">
            Book Now
          </button>
          <button onClick={() => setOpen((o) => !o)} className="xl:hidden grid h-11 w-11 place-items-center rounded-full border border-gold/40 bg-cream/70" aria-label="Open menu" data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="xl:hidden overflow-hidden bg-cream/95 backdrop-blur-xl"
            data-testid="mobile-nav"
          >
            <div className="px-6 pt-4 pb-8 flex flex-col">
              {NAV.map((n, i) => (
                <motion.button
                  key={n.id}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.05 * i }}
                  onClick={() => go(n.id)}
                  className="flex items-baseline gap-4 border-b border-gold/15 py-3.5 text-left font-serif text-2xl text-ink"
                  data-testid={`mobile-nav-${n.id}`}
                >
                  <span className="text-xs font-sans text-gold-dark">0{i + 1}</span>
                  {n.label}
                </motion.button>
              ))}
              <button onClick={() => go("contact")} className="btn-gold mt-6" data-testid="mobile-nav-book-btn">
                Book Now
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
